import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { apiGet } from "@/lib/api";
import { EVENT } from "@/lib/data";

const LiveSeats = ({ className = "" }) => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    const load = () => apiGet("/api/hype").then((d) => setRemaining(d.seats_remaining)).catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  if (remaining === null) return null;

  return (
    <span
      data-testid="live-seats-counter"
      className={`inline-flex items-center gap-2 text-sm text-[#F3D068] ${className}`}
    >
      <Flame size={15} className="text-[#F59E0B] flame-flicker shrink-0" />
      <span>
        Only <b className="font-bold">{remaining.toLocaleString()}</b> of{" "}
        {EVENT.capacity.toLocaleString()} seats still remain
      </span>
    </span>
  );
};

export default LiveSeats;
